import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoArmamentoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoArmamentoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexTipoArmamento(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoArmamento', name: 'TipoArmamento', title: 'Tipo de Armamento' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            tipoArmamentos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            tipoArmamento: {},
            
        };
    },
    methods: {
    
        newTipoArmamento() {
            this.tipoArmamento = {};
            this.$refs['frm-tipoArmamento'].show();
            // console.log("hhhhola")
        },
        showTipoArmamento(id) {
            this.isLoading=true;
            this.ss.showTipoArmamento(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoArmamento = response.data;
                    this.$refs['view-tipoArmamento'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoArmamento() {
            this.$refs['frm-tipoArmamento'].show();
            this.$refs['view-tipoArmamento'].hide();
        },
        cancelTipoArmamento() {
            if (this.tipoArmamento.id) {
                this.$refs['view-tipoArmamento'].show();
            }
            this.$refs['frm-tipoArmamento'].hide();
        },
        saveTipoArmamento() {
            this.ss.storeTipoArmamento(this.tipoArmamento).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoArmamento'].hide();
                    this.$refs['datatable-tipoArmamento'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoArmamento() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoArmamento(this.tipoArmamento)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoArmamento'].hide();
                                this.$refs['datatable-tipoArmamento'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-tipoArmamento'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-tipoArmamento'].show();
        },
        changePassword() {
            this.password.TipoArmamento = this.tipoArmamento.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-tipoArmamento'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-TipoArmamento').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoArmamento(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
